export default function function_with_timeout(callback, timeout = 1000) {
	let called = false;

	function wrapped_callback() {
		if (called) return;
		called = true;
		callback();
	}

	setTimeout(wrapped_callback, timeout);
	return wrapped_callback;
}
